import _ from 'lodash';
import moment from 'moment';
import { put } from 'redux-saga/effects';

import { changeLocale } from '@lib/actions';
import messageTemplatesResource from '@lib/resources/messageTemplatesResource';
import storage from '@lib/services/storageService';
import { isPatientLoginOnly } from 'utils/isPatientLoginOnly';

export default function* sagaChangeLocale(action: ReturnType<typeof changeLocale>) {
  const { payload: locale } = action;
  moment.locale(locale);
  const isWaitingRoomsPatients = window.location.pathname.includes('waitingroomspatients');

  // fetch message templates if token available
  if (storage.getToken() && !isPatientLoginOnly()) {
    yield put(
      messageTemplatesResource.fetchList({
        params: {
          lang: _.get(locale.match(/(\w+)-/), 1) || locale,
          parseWebSquigglies: isWaitingRoomsPatients ? true : undefined,
          platform: 'web',
        },
        meta: { ignoreErrors: [401] },
      }),
    );
  }
}
